import { UTCDate } from '@date-fns/utc';
import { Row } from '@tanstack/react-table';
import { isAfter, isBefore } from 'date-fns';
import { InvoiceEvidenceView } from '../../../../../types/entity-types';

export const sortPaidOnInvoiceDate = (
  rowA: Row<InvoiceEvidenceView>,
  rowB: Row<InvoiceEvidenceView>,
  columnId: string,
) => {
  const paidDateA = rowA.getValue<string>(columnId);
  const paidDateB = rowB.getValue<string>(columnId);

  if (paidDateA === 'Unknown' && paidDateB !== 'Unknown') {
    return 1;
  }

  if (paidDateB === 'Unknown' && paidDateA !== 'Unknown') {
    return -1;
  }

  if (paidDateA === 'Unknown' && paidDateB === 'Unknown') {
    return 0;
  }

  if (isBefore(new UTCDate(paidDateA), new UTCDate(paidDateB))) {
    return -1;
  }
  if (isAfter(new UTCDate(paidDateA), new UTCDate(paidDateB))) {
    return 1;
  }

  return 0;
};
